import React, { useCallback, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { FieldIcon } from '@jutro/components';
import de from 'date-fns/locale/de';
import cx from 'classnames';
import styles from './AdacDatePicker.module.scss';
import AdacDatePickerHeader from './AdacDatePickerHeader';

const datePickerStyles = {
    datePicker: 'jut__GenericDatePicker__datePicker'
};

const inputFieldStyles = {
    input: 'jut__InputField__input'
};

const MAX_AGE = 100;

export default function AdacDatePicker({
    date,
    setDate,
    label,
    isValid = true,
    placeholder,
    required,
    validationMessage,
    minYear,
    maxYear,
    externalTouched = false,
}) {
    const [isTouched, setTouched] = useState(false);
    const inputClasses = cx(
        {
            invalid: !isValid && isTouched
        },
        inputFieldStyles.input,
        datePickerStyles.datePicker
    );

    useEffect(() => {
        if (externalTouched && required) {
            setTouched(true);
        }
    }, [externalTouched, required]);

    const iconClasses = cx({
        [styles.invalid]: !isValid && isTouched
    });


    const renderCustomHeader = useCallback((headerProps) => {
        const today = new Date();
        const calculatedMaxYear = maxYear ? new Date(maxYear).getFullYear() : today.getFullYear();
        const calculatedMinYear = minYear ? new Date(minYear).getFullYear() : calculatedMaxYear - MAX_AGE;

        return (
            <AdacDatePickerHeader
                locale={de}
                minYear={calculatedMinYear}
                maxYear={calculatedMaxYear}
                {...headerProps}
            />
        );
    }, []);

    return (
        <>
            <label>{label}</label>
            <div className={datePickerStyles.datePicker} aria-expanded="true" aria-haspopup="true">
                <FieldIcon
                    icon="mi-calendar-today"
                    iconPosition="right"
                    className={iconClasses}
                >
                    <DatePicker
                        onBlur={() => setTouched(true)}
                        dateFormat="dd.MM.yyyy"
                        placeholderText={placeholder || 'TT.MM.JJJJ'}
                        locale={de}
                        selected={date}
                        onChange={(input) => setDate(input)}
                        className={inputClasses}
                        renderCustomHeader={renderCustomHeader}
                    />
                </FieldIcon>
            </div>
            {!isValid && isTouched && validationMessage && (
                <div className={styles.error}>
                    <span>{validationMessage}</span>
                </div>
            )}
        </>
    );
}
